module.exports = __webpack_public_path__ + "img/logoNew.7358599b.svg";